import { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MobileEmergencyBar from '../../components/MobileEmergencyBar';
import HeroSection from './components/HeroSection';
import CommercialCredibility from './components/CommercialCredibility';
import ServicesOverview from './components/ServicesOverview';
import TestimonialCarousel from './components/TestimonialCarousel';
import TrustCredentials from './components/TrustCredentials';
import EmergencyResponseCTA from './components/EmergencyResponseCTA';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 pt-16">
        <HeroSection />
        <CommercialCredibility />
        <ServicesOverview />
        <TestimonialCarousel />
        // <TrustCredentials />
        <EmergencyResponseCTA />
      </main>

      <Footer />
      <MobileEmergencyBar />
    </div>
  );
};

export default Homepage;